export default __webpack_public_path__ + "assets/5c336d757322b2f4e058f51d44effe9b.jpg";